export enum BillingItemType {
  PACKAGE = "PACKAGE",
  ADD_ON = "ADD_ON",
  HARDWARE = "HARDWARE",
  PAYMENT_METHOD = "PAYMENT_METHOD",
  EXTRA_DEVICE = "EXTRA_DEVICE",
}
